import React, { useState, useEffect } from "react";
import "./Pomodoro.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock, faPause, faPlay, faRotateLeft, faMugSaucer } from "@fortawesome/free-solid-svg-icons";

const Pomodoro = () => {
  const [timeLeft, setTimeLeft] = useState(null); // en segundos
  const [isRunning, setIsRunning] = useState(false);
  const [initialTime, setInitialTime] = useState(null); // para resetear
  const [isPaused, setIsPaused] = useState(false);
  const [mode, setMode] = useState("work"); // "work" o "break"
  const [lastWork, setLastWork] = useState(null); // "normal" o "focus"

  useEffect(() => {
    let timer = null;
    if (isRunning && !isPaused && timeLeft > 0) {
      timer = setInterval(() => {
        setTimeLeft((prevTime) => prevTime - 1);
      }, 1000);
    } else if (isRunning && timeLeft === 0) {
      if (mode === "work") {
        // Al terminar trabajo, inicia descanso según el tipo
        let breakTime = lastWork === "focus" ? 15 * 60 : 5 * 60;
        setMode("break");
        setTimeLeft(breakTime);
        setInitialTime(breakTime);
        setIsPaused(false);
        setIsRunning(true);
        alert("¡Tiempo finalizado! Es hora de un descanso.");
      } else {
        // Al terminar descanso, vuelve a selección
        setIsRunning(false);
        setTimeLeft(null);
        setInitialTime(null);
        setMode("work");
        setIsPaused(false);
        setLastWork(null);
        alert("¡Descanso terminado! Puedes empezar otro Pomodoro.");
      }
    }
    return () => clearInterval(timer);
  }, [isRunning, isPaused, timeLeft, mode, lastWork]);

  const formatTime = (seconds) => {
    const m = String(Math.floor(seconds / 60)).padStart(2, "0");
    const s = String(seconds % 60).padStart(2, "0");
    return `${m}:${s}`;
  };

  const startTimer = (minutes, workType) => {
    const totalSeconds = minutes * 60;
    setTimeLeft(totalSeconds);
    setInitialTime(totalSeconds);
    setIsRunning(true);
    setIsPaused(false);
    setMode("work");
    setLastWork(workType);
  };

  const resetTimer = () => {
    setTimeLeft(null);
    setIsRunning(false);
    setIsPaused(false);
    setInitialTime(null);
    setMode("work");
    setLastWork(null);
  };

  const togglePause = () => {
    setIsPaused(!isPaused);
  };

  return (
    <div className="container">
      <div className="timer-title">
        <FontAwesomeIcon icon={faClock} />
        <h1>Temporizador Pomodoro</h1>
      </div>

      {timeLeft === null ? (
        <div className="mode-selector">
          <p>Elige tu modo de trabajo:</p>
          <div className="button-group">
            <button onClick={() => startTimer(50, "normal")}>
              <FontAwesomeIcon icon={faClock} />
              Normal (50 min)
            </button>
            <button onClick={() => startTimer(120, "focus")}>
              <FontAwesomeIcon icon={faClock} />
              Trabajo Concentrado (2h)
            </button>
          </div>
        </div>
      ) : (
        <div className="active-timer">
          <h2 className="big-timer">{formatTime(timeLeft)}</h2>
          <div style={{ marginBottom: 8 }}>
            {mode === "break" && (
              <span style={{ color: "#28a745", fontWeight: "bold" }}>
                <FontAwesomeIcon icon={faMugSaucer} /> Descanso
              </span>
            )}
            {mode === "work" && (
              <span style={{ color: "#007bff", fontWeight: "bold" }}>
                <FontAwesomeIcon icon={faClock} /> Trabajo
              </span>
            )}
          </div>
          <div className="button-group">
            <button onClick={togglePause}>
              <FontAwesomeIcon icon={isPaused ? faPlay : faPause} />
              {isPaused ? " Reanudar" : " Pausar"}
            </button>
            <button onClick={resetTimer}>
              <FontAwesomeIcon icon={faRotateLeft} />
              Resetear
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Pomodoro;
